<template>
    <modal
        name="product-customisation-modal"
        width="1200"
        height="auto"
        scrollable
        adaptive
        @before-open="handleModalBeforeOpen"
        @opened="handleModalOpened"
    >
        <ProductVariations
            :product="product"
            :show-preview="true"
        />
    </modal>
</template>

<script>
import ProductVariations from '@/components/ProductVariations.vue';

export default {

    components: {
        ProductVariations,
    },

    data() {
        return {
            product: {
                variation_types: {},
            },
        };
    },

    beforeDestroy() {
        this.removeWindowResizeEventListener();
    },

    methods: {
        handleModalBeforeOpen({ params }) {
            this.product = params.product;
        },
        handleModalOpened() {
            this.addWindowResizeEventListener();
            this.loadFonts();
        },
        addWindowResizeEventListener() {
            window.addEventListener('resize', this.calculateImageScale);
        },
        removeWindowResizeEventListener() {
            window.removeEventListener('resize', this.calculateImageScale);
        },
        closeModal() {
            this.$modal.hide('product-customisation-modal');
        },
        loadFonts() {
            if (typeof window !== 'undefined' && this.product.text_font_family) {
                const WebFont = require('webfontloader');

                WebFont.load({
                    custom: {
                        families: [this.product.text_font_family],
                        urls: [this.product.text_font_css],
                    },
                });
            }
        },
    },

};
</script>

<style lang="scss" scoped>

</style>
